/*
    Marc: If the functions below aren't enough to fulfill the state needs, then
    please consider creating a custom state wrapper for that specific state.
    A reasonable example of a custom state wrapper is the "chatStateWrapper"
    function in the "./state.pm.ts" file. Targeting "state.chat[id][key]" was
    not something that the "stateWrapper" function alone could do.
*/

export const stateWrapper =
    (config) =>
    (execute, key?, options = { diffInput: true, diffOutput: false }) =>
    (...args) => {
        const { update, state } = config
        const { diffInput = true, diffOutput } = options

        if (key && diffInput) {
            const [value] = args

            if (state[key] === value) {
                // don't update if it's the same value
                return
            }
        }

        const previousValue = state[key]

        execute(...args)

        if (key && diffOutput && state[key] === previousValue) {
            // don't update if it's the same value
            return
        }

        if (state.skipPubsub) {
            return
        }

        update()
    }

export const stateWrapperShortform = (config) => {
    const { execute, ...other } = config
    const { state } = other

    const sW = stateWrapper(other)

    return (key?, options?) => {
        const exec =
            execute ??
            ((value: any) => {
                state[key] = value
            })
        return sW(exec, key, options)
    }
}
